// extracted by mini-css-extract-plugin
module.exports = {"pt-active-sign":"pt-active-sign-3960b7f387592a6a2da745aa5f7361f3"};